import { ElementRef, HostListener, Directive, Input, AfterContentChecked } from '@angular/core';

const maxLookupRetries = 3;
@Directive({
    selector: '[autosize]',
    standalone: false
})
export class AutosizeDirective implements AfterContentChecked {
  @Input() minRows: number;
  @Input() maxRows: number;

  private retries = 0;
  private textAreaEl: any;

  @HostListener('input', ['$event.target'])
  onInput(textArea: HTMLTextAreaElement): void {
    this.adjust();
  }
  constructor(public element: ElementRef) {
    if (this.element.nativeElement.tagName !== 'TEXTAREA') {
      this.findNestedTextArea();
    } else {
      this.textAreaEl = this.element.nativeElement;
    }
  }
  findNestedTextArea() {
    this.textAreaEl = this.element.nativeElement.querySelector('TEXTAREA');

    if (!this.textAreaEl && this.element.nativeElement.shadowRoot) {
      this.textAreaEl = this.element.nativeElement.shadowRoot.querySelector('TEXTAREA');
    }

    if (!this.textAreaEl) {
      if (this.retries >= maxLookupRetries) {
        console.warn('textarea not found');
      } else {
        this.retries++;
        setTimeout(() => {
          this.findNestedTextArea();
        }, 100);
      }
    }
  }
  ngAfterContentChecked(): void {
    this.adjust();
  }
  adjust(): void {
    if (this.textAreaEl) {
      const clone = this.textAreaEl.cloneNode(true);
      const parent = this.textAreaEl.parentNode;
      clone.style.visibility = 'hidden';
      parent.appendChild(clone);

      clone.style.overflow = 'hidden';
      clone.style.height = 'auto';

      const lineHeight = this.getLineHeight();
      let height = clone.scrollHeight;
      const rowsCount = height / lineHeight;
      if (this.minRows && this.minRows >= rowsCount) {
        clone.style.overflow = 'auto';
        height = this.minRows * lineHeight;
      } else if (this.maxRows && this.maxRows <= rowsCount) {
        clone.style.overflow = 'auto';
        height = this.maxRows * lineHeight;
      }

      this.textAreaEl.style.height = height + 'px';
      parent.removeChild(clone);
    }
  }

  private getLineHeight() {
    let lineHeight = parseInt(this.textAreaEl.style.lineHeight, 10);
    if (isNaN(lineHeight)) {
      const fontSize = window.getComputedStyle(this.textAreaEl, null).getPropertyValue('font-size');
      lineHeight = Math.floor(parseInt(fontSize.replace('px', ''), 10) * 1.5);
    }

    return lineHeight;
  }
}
